import script from "./TheLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./TheLoading.vue?vue&type=script&setup=true&lang=ts"

import "./TheLoading.vue?vue&type=style&index=0&id=70a20afc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a20afc"]])

export default __exports__